export default __webpack_public_path__ + "static/media/MDA.40be180d.svg";